// src/services/businessProjectApi.ts
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { 
  OMNISTACK_BASE_URL, 
  getPrepareHeaders 
} from '@/hooks/common/common-functions'

export const businessProjectApi = createApi({
  reducerPath: 'businessProjectApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${OMNISTACK_BASE_URL}business-project`,
    prepareHeaders: (headers) => {
      // Add standard headers
      getPrepareHeaders({
        headers,
        isClientApiKey: true,
      });
      
      // Add business-specific API key
      const businessApiKey = localStorage.getItem('businessApiKey');
      if (businessApiKey) {
        headers.set('business-x-api-key', businessApiKey);
      }
      
      return headers;
    },
  }),
  tagTypes: ['ProjectDetails', 'ProjectWeatherDetails', 'ProjectDelays'],
  endpoints: (builder) => ({
    // Get weather-related details for a project
    getProjectWeatherDetails: builder.query({
      query: ({ businessId, projectId }) => ({
        url: `/weather-details/${businessId}/project/${projectId}`,
      }),
      providesTags: (_, __, { projectId }) => [
        { type: 'ProjectWeatherDetails', id: projectId },
        { type: 'ProjectDelays', id: projectId }
      ],
    }),
    
    // Add a weather-related delay to a project
    addWeatherDelay: builder.mutation({
      query: ({ businessId, projectId, delayData }) => ({
        url: `/weather-delay/${businessId}/project/${projectId}`,
        method: 'POST',
        body: delayData,
      }),
      invalidatesTags: (_, __, { projectId }) => [
        { type: 'ProjectDelays', id: projectId },
        { type: 'ProjectWeatherDetails', id: projectId }
      ],
    }),
    
    // Get all weather-related delays for a project
    getProjectDelays: builder.query({
      query: ({ businessId, projectId }) => ({
        url: `/weather-delays/${businessId}/project/${projectId}`,
      }),
      providesTags: (_, __, { projectId }) => [
        { type: 'ProjectDelays', id: projectId }
      ],
    }),
  }),
})

export const {
  useGetProjectWeatherDetailsQuery,
  useAddWeatherDelayMutation,
  useGetProjectDelaysQuery,
} = businessProjectApi